import { render, staticRenderFns } from "./focus-items-nutrition-allergens-cmp.vue?vue&type=template&id=f17adc48&scoped=true"
import script from "./focus-items-nutrition-allergens-cmp.vue?vue&type=script&lang=js"
export * from "./focus-items-nutrition-allergens-cmp.vue?vue&type=script&lang=js"
import style0 from "./focus-items-nutrition-allergens-cmp.vue?vue&type=style&index=0&id=f17adc48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17adc48",
  null
  
)

export default component.exports